var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 200,
    viewBox: "0 0 282 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.785 42.127L236.713 28.7759C231.216 14.2976 212.607 10.3062 201.649 21.2642L171.787 51.1263L171.713 51.0985L163.231 28.7759C157.734 14.2976 139.125 10.3062 128.167 21.2642L98.3053 51.1263L98.2314 51.0985L89.7496 28.7759C84.2521 14.2976 65.6437 10.3062 54.6857 21.2642L24.8236 51.1263L24.7497 51.0985L16.2678 28.7759C10.7703 14.2976 -7.83801 10.3062 -18.7961 21.2642L-102.866 105.362C-114.296 116.791 -109.371 136.287 -93.8947 140.916L-82.7241 144.26C-75.8407 146.321 -70.4541 151.707 -68.3937 158.591L-65.049 169.761C-60.4107 185.247 -40.9246 190.162 -29.4954 178.733L1.7064 147.531L1.78031 147.55L8.42352 169.752C13.0617 185.238 32.5479 190.153 43.9771 178.724L75.1696 147.522L75.2436 147.54L81.8868 169.743C86.525 185.228 106.011 190.144 117.44 178.714L148.642 147.513L148.716 147.531L155.359 169.734C159.997 185.219 179.484 190.134 190.913 178.705L275.011 94.6073C285.96 83.6585 281.977 65.0502 267.499 59.5434L254.148 54.471C248.447 52.2997 243.938 47.8 241.767 42.09L241.785 42.127Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282,
    height: 170,
    fill: "white",
    transform: "translate(0 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/AppIcon.e62d2940ecf0123fabc98c5876b4e63f.svg";
export { ForwardRef as ReactComponent };